import Questions from "components/admin/Questions/Questions"

const AttendeeSettings = props => {
  return (
    <section className="mb-4 d-f@lg max-width-center-stage">
      <div className="f-2">
        <section className="mb-4">
          <Questions {...props} group="attendee" />
        </section>
      </div>
    </section>
  )
}
export default AttendeeSettings
